import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import edit_icon from "../../../common/assets/images/editing (1).png";
import trash_icon from "../../../common/assets/images/trash.png";
import blue_add_icon from "../../../common/assets/images/blueaddicon.png";
import {
  fetchQueueRules,
  deleteQueueRules,
} from "../../../store/queueSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";

const RoutingRules = ({
  showRuleAddSection,
  handleRuleAdder,
  routing_rules = [],
  formData,
  setFormData,
  selectedRules,
  setSelectedRules
}) => {
  const operatorSymbolMap = {
    equals: ":",
    "greater than or equals": "≥",
    "less than or equals": "≤",
    "greater than": ">",
    "less than": "<",
    "not equals": "≠",
  };
  
  const dispatch = useDispatch();
  const queueRules = useSelector((state) => state.queue.queueRules);

  const [newRule, setNewRule] = useState({
    rule_name: "",
    rule_id: "",
    operator: "",
    rule_condition_id: "",
    value_to_compare: "",
  });

  const [editIndex, setEditIndex] = useState(null);
 
  const handleEditClick = (rule, index) => {
    setNewRule({
      rule_name: rule.rule_name,
      rule_id: rule.rule_id,
      operator: rule.operator,
      rule_condition_id: rule.rule_condition_id,
      value_to_compare: rule.value_to_compare,
    });
    setEditIndex(index);
    if (!showRuleAddSection) handleRuleAdder();
  };

  const handleDeleteQueueRule = (ruleId, conditionId, queueId) => {
    setSelectedRules((prev) => prev.filter((id) => id !== ruleId));

    if (!conditionId) {
      const updatedRules = formData.routing_rules.filter(
        (rule) => rule.rule_id !== ruleId
      );
      setFormData((prev) => ({
        ...prev,
        routing_rules: updatedRules,
      }));
      return;
    }

    const payload = {
      queue_id: queueId,
      rule_condition_ids: [conditionId],
    };

    dispatch(deleteQueueRules(payload)).then(() => {
      const updatedRules = formData.routing_rules.filter(
        (rule) => rule.rule_condition_id !== conditionId
      );
      setFormData((prev) => ({
        ...prev,
        routing_rules: updatedRules,
      }));
    });
  };

  // const handleRuleChange = (rule) => {
  //   if (editIndex === null && selectedRules.includes(rule.code_workflow_queue_rule_id)) {
  //     toast.error("Rule already exists");
  //     return;
  //   }

  //   setNewRule((prev) => ({
  //     ...prev,
  //     rule_name: rule.code_workflow_queue_rule_name,
  //     rule_id: rule.code_workflow_queue_rule_id,
  //   }));
  // };
const handleRuleChange = (rule) => {
  // Prevent picking an already used rule when editing
  if (
    selectedRules.includes(rule.code_workflow_queue_rule_id) &&
    formData.routing_rules[editIndex]?.rule_id !== rule.code_workflow_queue_rule_id
  ) {
    toast.error("This rule is already selected.");
    return;
  }

  setNewRule((prev) => ({
    ...prev,
    rule_name: rule.code_workflow_queue_rule_name,
    rule_id: rule.code_workflow_queue_rule_id,
  }));
};

  const handleFetchQueueRules = () => {
    dispatch(fetchQueueRules());
  };

  useEffect(() => {
    handleFetchQueueRules();
  }, []);
useEffect(() => {
  if (formData?.routing_rules?.length > 0) {
    setSelectedRules(formData.routing_rules.map(rule => rule.rule_id));
  }
}, [formData]);
  return (
    <div className="config-rules-wrapper">
      <ToastContainer autoClose={5000} />
      
      {routing_rules.map((rule, index) => {
        const operatorSymbol = operatorSymbolMap[rule.operator] || ":";
        return (
          <div className="inner-rule-wrapper mb-2" key={index}>
            <div>
               
              <label className="rule-label">
                {rule.rule_name} {operatorSymbol}{" "}
              </label>
              <span className="rule-value"> {rule.value_to_compare}</span>
            </div>
            <div>
              <img
                src={edit_icon}
                style={{ height: "14px" }}
                alt="edit"
                onClick={() => handleEditClick(rule, index)}
              />
              <img
                src={trash_icon}
                style={{
                  height: "16px",
                  marginLeft: "2px",
                  cursor: "pointer",
                }}
                alt="delete"
                onClick={() =>
                  handleDeleteQueueRule(
                    rule.rule_id,
                    rule.rule_condition_id,
                    formData?.queue_id
                  )
                }
              />
            </div>
          </div>
        );
      })}

      {showRuleAddSection && (
        <div className="d-flex gap-3 mt-3 routing-rule-add">
          <Dropdown className="form-dropdown select-rule-dropdown" style={{ width: "200px" }}>
            <Dropdown.Toggle>
              {newRule.rule_name || "Select Rule"}
            </Dropdown.Toggle>
            <Dropdown.Menu className="select-rule-dropdown-menu">
              {queueRules?.rules_data?.map((rule) => (
                <Dropdown.Item
                  key={rule.code_workflow_queue_rule_id}
                  onClick={() => handleRuleChange(rule)}
                >
                  {rule.code_workflow_queue_rule_name}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>

          <Dropdown className="form-dropdown select-operator-dropdown" style={{ width: "200px" }}>
            <Dropdown.Toggle>
              {newRule.operator || "Select Operator"}
            </Dropdown.Toggle>
            <Dropdown.Menu className="select-operator-dropdown-menu">
              {[
                "equals (==)",
                "not equals (!=)",
                "greater than (>)",
                "less than (<)",
                "GREATER THAN OR EQUALS (≥)",
                "less than or equals (≤)",
                "starts with",
                "ends with",
                "pattern matching",
              ].map((op, idx) => (
                <Dropdown.Item
                  key={idx}
                  onClick={() =>
                    setNewRule((prev) => ({ ...prev, operator: op }))
                  }
                >
                  {op}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>

          <input
            type="text"
            value={newRule.value_to_compare}
            onChange={(e) =>
              setNewRule((prev) => ({
                ...prev,
                value_to_compare: e.target.value,
              }))
            }
          />

          <button
            className="add-rule-btn"
                onClick={(e) => {
                  e.preventDefault();
                  if (
                    newRule.rule_name &&
                    newRule.operator &&
                    newRule.value_to_compare.trim()
                  ) {
                    const updatedRules = [...(formData?.routing_rules || [])];
                  
                    // Check if the selected rule_id is already used by another rule (not current one)
                    const ruleExists = updatedRules.some(
                      (rule, idx) =>
                        rule.rule_id === newRule.rule_id && idx !== editIndex
                    );
                  
                    if (ruleExists) {
                      toast.error("Rule with this name already exists.");
                      return;
                    }
                  
                    if (editIndex !== null) {
                      const oldRuleId = updatedRules[editIndex].rule_id;
                    
                      // Replace the rule at the same index
                      updatedRules[editIndex] = {
                        ...updatedRules[editIndex],
                        ...newRule,
                      };
                    
                      // Update selectedRules: remove old rule_id and add new one if changed
                      setSelectedRules((prev) => {
                        const filtered = prev.filter((id) => id !== oldRuleId);
                        return [...new Set([...filtered, newRule.rule_id])];
                      });
                    } else {
                      // Add new rule
                      updatedRules.push({ ...newRule });
                      setSelectedRules((prev) => [...prev, newRule.rule_id]);
                    }
                  
                    // Update form data
                    setFormData((prev) => ({
                      ...prev,
                      routing_rules: updatedRules,
                    }));
                  
                    // Reset
                    setNewRule({
                      rule_id: "",
                      rule_name: "",
                      operator: "",
                      value_to_compare: "",
                    });
                    setEditIndex(null);
                  }
                }}


          >
            {editIndex !== null ? "Update" : "Add"}
          </button>
        </div>
      )}

      <button className="route-adding-btn m-auto" onClick={handleRuleAdder}>
        {showRuleAddSection ? "" : <img src={blue_add_icon} alt="plus" />}
        {showRuleAddSection ? "Cancel" : "Add Routing Rule"}
      </button>
    </div>
  );
};

export default RoutingRules;
